import 'firebase/firestore';
import React, { useState } from 'react';
import './HomePage.css';
import Notch from './components/notch';
import Window from './components/window';
import logo from './logo.svg';

function HomePage() {
    const [backgroundColor, setBackgroundColor] = useState('black');
    const [textColor, setTextColor] = useState('white');
    const [windowBgColor, setWindowBgColor] = useState('#fff');
    const [topbarBgColor, settopBarBgColor] = useState('#CFCFCF');
  
    const generateRandomColor = () => {
      // Generate random colors when the button is clicked
      const randomBackgroundColor = getRandomColor();
      const randomTextColor = getRandomColor();
  
      setBackgroundColor(randomBackgroundColor);
      setTextColor(randomTextColor);
      setWindowBgColor(randomTextColor);
      settopBarBgColor('#000')
    };
  
    // Function to generate a random color
    const getRandomColor = () => {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    };

    const changeColors = (textcolor, bgcolor) =>{
        setBackgroundColor(textcolor);
        setTextColor(bgcolor);
        setWindowBgColor(bgcolor);
        if(bgcolor!=='#F6769A'){
            settopBarBgColor('#CFCFCF');
        }
        else
        settopBarBgColor('black');
    }
    
  return (
    
    <body bgColor="black">
    <div>
      <div className='home-page'
        style={{
          backgroundColor: backgroundColor,
          color: textColor,
        }}
      >
      <Notch color={textColor} textcolor={backgroundColor} />
        <div class="circle-container">
            <div class="circle" style={{backgroundColor: '#fff'}} onClick={() => changeColors('#fff', '#000')}/>
            <div class="circle" style={{backgroundColor: '#F6769A'}} onClick={() => changeColors('#1E3264', '#F6769A')}/>
            <div class="circle" style={{backgroundColor: '#CCF656'}} onClick={() => changeColors('#CCF656', '#000')}/>
            <img src={require('./rainbow.png')} className='circle' alt='' onClick={generateRandomColor}/>
        </div>
        <h1 className='hidden'>Personal Portfolio Template</h1>
        <h1 className='hidden'>Praveen Thavantharan</h1>
        <h1 className='hidden'>Praveen</h1>
        <h1 className="resizable-text">PRAVEEN.DEV</h1>
        <p className='magic-text'>made with magic</p>
        
        <div className='scroll-heading'><h2>My Projects -&gt;</h2></div>
        <div className="scroll-container">
         <Window windowColor={windowBgColor} topbarColor={topbarBgColor} bgColor={backgroundColor} collectionName = "projects"/>
        </div>
        <br/>
        <div className='scroll-heading' id='about'><h2>About me -&gt;</h2></div>
        <div className="scroll-container">
         <Window windowColor={windowBgColor} topbarColor={topbarBgColor} bgColor={backgroundColor} collectionName = "about"/>
        </div>
        <div className='scroll-heading' id='about'><h1>Praveen Thavantharan -&gt;  </h1></div>
        
        <footer>
          <p>Powered by React JS <img src={logo} className="react-logo" alt="logo" /></p> 
      </footer>

      </div>
      
    </div>
    
    </body>
  );
}
//<BgComponent/><BackgroundCanvas/>

export default HomePage;
